<template>
  <v-container>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2
          class="primary--text"
        >
          Recommended Classes for {{ currentBalletClass.title }}
        </h2>
      </v-flex>
    </v-layout>
    <v-layout
      row
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <v-btn
          :href="this.classUrl"
          target="_blank"
        >
            Visit On-Demand Class
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout
      row
      pt-10
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <h2>{{ this.recommendationTypes[this.recommendationType] }}</h2>
        <p
          v-for="video in this.loadedRecommendations"
          :key="video.id"
        >
          {{ video.title }} |
            <a
            :href="video.pageURL"
            target="_blank"
          >
              Visit On-Demand Class
          </a>
        </p>
      </v-flex>
    </v-layout>
    <v-layout
      row
    >
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <v-btn
          :to="{ name: 'EditRecommendedClasses', params: { id: this.id } }"
        >
          Edit Recommendations
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['id'],
    data () {
      return {
        title: '',
        classUrl: '',
        recommendedUrl1: '',
        recommendedUrl2: '',
        recommendedUrl3: '',
        recommendationType: '',
        recommendationTypes: {
          'more': 'Keep Dancing',
          'warmup': 'Recommended Warmups',
          'mix': 'Recommended Classes'
        }
      }
    },
    computed: {
      currentBalletClass () {
        return this.$store.getters.currentBalletClass
      },
      currentBalletClassRecommendations () {
        return this.$store.getters.currentBalletClassRecommendations
      },
      loadedRecommendations () {
        return this.$store.getters.loadedRecommendations
      }
    },
    created () {
      this.$store.dispatch('loadBalletClass', this.id).then(() => {
        this.title = this.currentBalletClass.title
      })
      this.$store.dispatch('loadBalletClassRecommendations', this.id).then(() => {
        if (this.currentBalletClassRecommendations !== null) {
          this.classUrl = this.currentBalletClassRecommendations.classUrl
          this.recommendedUrl1 = this.currentBalletClassRecommendations.recommendedUrl1
          this.recommendedUrl2 = this.currentBalletClassRecommendations.recommendedUrl2
          this.recommendedUrl3 = this.currentBalletClassRecommendations.recommendedUrl3
          this.recommendationType = this.currentBalletClassRecommendations.recommendationType
          this.$store.dispatch('loadRecommendations', [this.recommendedUrl1, this.recommendedUrl2, this.recommendedUrl3]).then(() => {
            const urls = this.loadedRecommendations.map(video => video.pageURL)
            if (urls.includes(this.recommendedUrl1) === false) {
              this.loadedRecommendations.push({ title: 'Missing from Database', pageURL: this.recommendedUrl1 })
            }
            if (urls.includes(this.recommendedUrl2) === false) {
              this.loadedRecommendations.push({ title: 'Missing from Database', pageURL: this.recommendedUrl2 })
            }
            if (urls.includes(this.recommendedUrl3) === false) {
              this.loadedRecommendations.push({ title: 'Missing from Database', pageURL: this.recommendedUrl3 })
            }
          })
        }
      })
    }
  }
</script>
